<template>
<div class="form border resent-confirm">
    <h1>{{$lang('TEXT_RESENT_MAIL_SUCCESS')}}</h1>
    <h2>
        <a href="javascript:void(0)" @click="resentMail">{{$lang('TITLE_CLICK_RESEND_EMAIL')}}</a>
    </h2>
    <router-link :to="{name: 'home'}">{{$lang('TITLE_RETURN_INDEX')}}</router-link>
</div>
</template>

<script>
export default {
    data() {
        return {
            hash: this.$route.params.hash,
        };
    },
    methods: {
        resentMail() {
            this.$apis.user
                .resentConfirmMail({
                    hash: this.hash,
                })
                .then(resp => {
                    this.notification.success(this.$lang("TEXT_RESENT_MAIL_SUCCESS"))
                })
                .catch(err => {
                    this.notification.error(this.$lang("發送驗證郵件失败"))
                });
        },
        checkHashCode(hash) {
            this.$apis.checkHashCode({
                hash
            }).then(resp => {

            }).catch(err => {
                this.$router.push({
                    path: '/' + this.$route.params.locale + '/'
                })
            })
        }
    },
    created() {
        this.checkHashCode(this.hash);
    }
};
</script>
